import type { MenuItem } from '@/types';

/**
 * Getting Started docs menu
 */
export const gettingStartedMenu: MenuItem[] = [
  {
    label: 'Portal-Based Demo',
    path: '/getting-started/basic-demo',
  },
  {
    label: 'Web Example',
    path: '/getting-started/websdk-demo',
  },
  {
    label: 'API Workflow',
    path: '/getting-started/api-workflow',
  },
  {
    label: 'Additional Resources',
    path: '/getting-started/advanced-demo',
  },
  {
    label: 'Mobile App Demos',
    path: '/getting-started/mobile-app-demos',
  },
];